import CatalogsEthContent from "./CatalogsEthContent";

export default CatalogsEthContent;
